export default {
    licencas: {}
}
